import { c as _c } from "react/compiler-runtime";
import { AvatarGroup } from '@precis-digital/kurama/Avatar';
import ThemedAvatar from 'shared/components/Themed/Avatar';
import Grid from '@precis-digital/kurama/Grid';
import Tooltip from '@precis-digital/kurama/Tooltip';
import { type ReactElement } from 'react';
import { uniq } from 'ramda';
import { StyledTypographyAnnotation } from './StyledTypographyAnnotation';
import { StyledTypographyTitleWithAvatars } from './StyledTypographyTitleWithAvatars';
import type { TypographyProps } from '@precis-digital/kurama/Typography';
export interface TitleWithAvatarsAffectedEntitiesProps {
  title: string;
  titleVariant?: TypographyProps['variant'];
  affectedLabel: string;
  avatarsIconUrl?: string;
  avatars: Array<{
    name: string;
    iconUrl: string;
  }> | null;
  avatarLabel: string;
  avatarsTooltipTitle?: string | null;
  avatarsTooltipBody?: ReactElement | null;
  entities: string[] | null;
  entitiesLabel: string | null;
  entitiesTooltipTitle?: string | null;
  entitiesTooltipBody?: ReactElement | null;
  shouldGreyRow?: boolean;
}
const TitleWithAvatarsAffectedEntities = t0 => {
  const $ = _c(66);
  const {
    title,
    titleVariant,
    affectedLabel,
    avatarsIconUrl,
    avatars,
    avatarLabel,
    avatarsTooltipTitle,
    avatarsTooltipBody,
    entities,
    entitiesLabel,
    entitiesTooltipTitle,
    entitiesTooltipBody,
    shouldGreyRow
  } = t0;
  let T0;
  let T1;
  let hasAvatarsTooltip;
  let hasEntitiesTooltip;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let withEntities;
  if ($[0] !== avatars || $[1] !== avatarsIconUrl || $[2] !== avatarsTooltipBody || $[3] !== avatarsTooltipTitle || $[4] !== entities || $[5] !== entitiesLabel || $[6] !== entitiesTooltipBody || $[7] !== entitiesTooltipTitle) {
    const uniqueIcons = avatarsIconUrl != null ? [avatarsIconUrl] : uniq(avatars?.map(_temp) ?? []);
    withEntities = entities != null && entitiesLabel != null;
    hasAvatarsTooltip = avatarsTooltipTitle != null && avatarsTooltipBody != null;
    hasEntitiesTooltip = entitiesTooltipTitle != null && entitiesTooltipBody != null;
    T1 = Grid;
    t4 = "flex";
    t5 = "center";
    t6 = "4px";
    T0 = AvatarGroup;
    t1 = "small";
    t2 = 2;
    t3 = uniqueIcons.map(_temp2);
    $[0] = avatars;
    $[1] = avatarsIconUrl;
    $[2] = avatarsTooltipBody;
    $[3] = avatarsTooltipTitle;
    $[4] = entities;
    $[5] = entitiesLabel;
    $[6] = entitiesTooltipBody;
    $[7] = entitiesTooltipTitle;
    $[8] = T0;
    $[9] = T1;
    $[10] = hasAvatarsTooltip;
    $[11] = hasEntitiesTooltip;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = withEntities;
  } else {
    T0 = $[8];
    T1 = $[9];
    hasAvatarsTooltip = $[10];
    hasEntitiesTooltip = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    withEntities = $[18];
  }
  let t7;
  if ($[19] !== T0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3) {
    t7 = <T0 size={t1} max={t2}>{t3}</T0>;
    $[19] = T0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const t8 = avatars?.length ?? 0;
  let t9;
  if ($[24] !== affectedLabel || $[25] !== hasAvatarsTooltip || $[26] !== t8) {
    t9 = <StyledTypographyAnnotation variant="body3" $hasTooltip={hasAvatarsTooltip}>{t8} {affectedLabel}</StyledTypographyAnnotation>;
    $[24] = affectedLabel;
    $[25] = hasAvatarsTooltip;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== T1 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t9) {
    t10 = <T1 display={t4} alignItems={t5} gap={t6}>{t7}{t9}</T1>;
    $[28] = T1;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  const affectedAvatarsContent = t10;
  let t11;
  if ($[35] !== affectedLabel || $[36] !== entities || $[37] !== hasEntitiesTooltip || $[38] !== withEntities) {
    t11 = withEntities ? <Grid display="flex" alignItems="center" gap="4px"><StyledTypographyAnnotation variant="body3" $hasTooltip={hasEntitiesTooltip}>{entities.length} {affectedLabel}</StyledTypographyAnnotation></Grid> : null;
    $[35] = affectedLabel;
    $[36] = entities;
    $[37] = hasEntitiesTooltip;
    $[38] = withEntities;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  const affectedEntitiesContent = t11;
  const t12 = titleVariant ?? "h3";
  let t13;
  if ($[40] !== shouldGreyRow || $[41] !== t12 || $[42] !== title) {
    t13 = <StyledTypographyTitleWithAvatars $isTitleGreyed={shouldGreyRow} variant={t12} title={title}>{title}</StyledTypographyTitleWithAvatars>;
    $[40] = shouldGreyRow;
    $[41] = t12;
    $[42] = title;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== affectedAvatarsContent || $[45] !== avatarLabel || $[46] !== avatarsTooltipBody || $[47] !== avatarsTooltipTitle) {
    t14 = avatarsTooltipBody != null ? <Tooltip title={avatarsTooltipTitle ?? avatarLabel} body={avatarsTooltipBody} kind="multiline" maxWidth="400px">{affectedAvatarsContent}</Tooltip> : affectedAvatarsContent;
    $[44] = affectedAvatarsContent;
    $[45] = avatarLabel;
    $[46] = avatarsTooltipBody;
    $[47] = avatarsTooltipTitle;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== avatarLabel) {
    t15 = avatarLabel.toLowerCase();
    $[49] = avatarLabel;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== t15) {
    t16 = <StyledTypographyAnnotation variant="body3" $hasTooltip={false}>{t15}</StyledTypographyAnnotation>;
    $[51] = t15;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== affectedEntitiesContent || $[54] !== entitiesLabel || $[55] !== entitiesTooltipBody || $[56] !== entitiesTooltipTitle || $[57] !== withEntities) {
    t17 = withEntities && <><StyledTypographyAnnotation variant="body3" $hasTooltip={false}>•</StyledTypographyAnnotation>{entitiesTooltipBody != null ? <Tooltip title={entitiesTooltipTitle ?? entitiesLabel} body={entitiesTooltipBody} kind="multiline" maxWidth="400px">{affectedEntitiesContent}</Tooltip> : affectedEntitiesContent}<StyledTypographyAnnotation variant="body3" $hasTooltip={false}>{entitiesLabel.toLowerCase()}</StyledTypographyAnnotation></>;
    $[53] = affectedEntitiesContent;
    $[54] = entitiesLabel;
    $[55] = entitiesTooltipBody;
    $[56] = entitiesTooltipTitle;
    $[57] = withEntities;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  let t18;
  if ($[59] !== t14 || $[60] !== t16 || $[61] !== t17) {
    t18 = <Grid container={true} alignItems="center" gap="4px" overflow="hidden" flexWrap="nowrap">{t14}{t16}{t17}</Grid>;
    $[59] = t14;
    $[60] = t16;
    $[61] = t17;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  let t19;
  if ($[63] !== t13 || $[64] !== t18) {
    t19 = <Grid container={true} flexDirection="column" overflow="hidden" flexWrap="wrap">{t13}{t18}</Grid>;
    $[63] = t13;
    $[64] = t18;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  return t19;
};
export default TitleWithAvatarsAffectedEntities;
function _temp(t0) {
  const {
    iconUrl
  } = t0;
  return iconUrl;
}
function _temp2(icon) {
  return <ThemedAvatar key={icon} size="small" kind="image" imageUrl={icon} />;
}